// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  scrollbar-width: thin;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 8px;
}

/* Card container */
.card {
  max-width: 100%;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 12px;
}

/* Header (title and buttons) */
.card-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}

.btn-link i {
  font-size: 16px;
}

/* Grid layout for time slots and schedules */
.schedule-grid {
  display: grid;
  grid-template-columns: 160px repeat(auto-fill, 50px); /* 160px for doctor names, 50px for each time block */
  gap: 5px; /* Gap between blocks */
  align-items: center;
}

.schedule-header {
  font-weight: bold;
  text-align: center;
}

.schedule-name {
  font-weight: bold;
  text-align: left;
}

/* Time block for each doctor */
.schedule-block {
  width: 50px; /* Width for each time block */
  height: 30px; /* Adjust height if needed */
  border-radius: 4px;
}

/* Color styles for schedule blocks */
.slot-orange {
  background-color: #ff9933;
}

.slot-grey {
  background-color: #808080;
}

.slot-green {
  background-color: #33cc33;
}

.slot-purple {
  background-color: #800080;
}

/* Responsive design */
@media (max-width: 768px) {
  .card-title {
    font-size: 16px;
  }
  .schedule-grid {
    grid-template-columns: 140px repeat(auto-fill, 40px);
  }
  .schedule-block {
    width: 40px;
  }
}
table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

td, th {
  border: 1px solid transparent;
  text-align: left;
  padding: 4px;
  width: auto;
}

.card {
  height: auto !important;
}

.appointment-card {
  height: 240px !important;
  max-height: 240px !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 15px !important;
}

.dashboard-appointments-column {
  align-self: flex-start;
}

.dashboard-appointments-column > * {
  width: 100%;
}

.dashboard-appointments-card {
  height: 240px !important;
  max-height: 240px !important;
}

.appointment-card .card-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  padding: 12px 12px 8px !important;
}

.appointment-card .appointments-list {
  flex: 1 1;
  overflow-y: auto !important;
  overflow-x: hidden;
  min-height: 0;
  margin-top: 0;
}

.appointment-card .appointment-row-accent {
  border-left: 5px solid transparent;
  padding-left: 10px;
  width: 100%;
  overflow: hidden;
}

.dashboard-appointments-card .card-title {
  margin-bottom: 0;
}

.dashboard-appointments-card .appointments-list .list-group-item {
  padding: 8px 0;
}

.doctor-schedule {
  height: 400px !important;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-container .tooltip {
  visibility: hidden;
  width: 150px;
  background-color: rgba(0, 0, 0, 0.9);
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%; /* Position the tooltip above the div */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  border: 1px solid black;
}

.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/style/dashboard.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA,sCAAA;AACA;EACE,UAAA;AACF;;AAEA,mBAAA;AACA;EACI,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEE,+BAAA;AACA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEE;EACE,eAAA;AACJ;;AAEE,6CAAA;AACA;EACE,aAAA;EACA,oDAAA,EAAA,qDAAA;EACA,QAAA,EAAA,uBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,iBAAA;EACA,kBAAA;AACJ;;AAEE;EACE,iBAAA;EACA,gBAAA;AACJ;;AAEE,+BAAA;AACA;EACE,WAAA,EAAA,8BAAA;EACA,YAAA,EAAA,4BAAA;EACA,kBAAA;AACJ;;AAEE,qCAAA;AACA;EACE,yBAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE,sBAAA;AACA;EACE;IACE,eAAA;EACJ;EAEE;IACE,oDAAA;EAAJ;EAGE;IACE,WAAA;EADJ;AACF;AAIE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAFJ;;AAKE;EACE,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAFJ;;AAKE;EACE,uBAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,8BAAA;AAFJ;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,wBAAA;EACA,4BAAA;AAFF;;AAKA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,iCAAA;AAFF;;AAKA;EACE,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;AAFF;;AAKA;EACE,kCAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAMA;EACE,wBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,qBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA,EAAA,uCAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,wBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,UAAA;AAHF","sourcesContent":["* {\n  scrollbar-width: thin;\n}\n\n/* Works on Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n  width: 8px;\n}\n\n/* Card container */\n.card {\n    max-width: 100%;\n    border: 1px solid #ddd;\n    background-color: #f9f9f9;\n    padding: 10px;\n    border-radius: 12px;\n  }\n  \n  /* Header (title and buttons) */\n  .card-title {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 0;\n  }\n  \n  .btn-link i {\n    font-size: 16px;\n  }\n  \n  /* Grid layout for time slots and schedules */\n  .schedule-grid {\n    display: grid;\n    grid-template-columns: 160px repeat(auto-fill, 50px); /* 160px for doctor names, 50px for each time block */\n    gap: 5px; /* Gap between blocks */\n    align-items: center;\n  }\n  \n  .schedule-header {\n    font-weight: bold;\n    text-align: center;\n  }\n  \n  .schedule-name {\n    font-weight: bold;\n    text-align: left;\n  }\n  \n  /* Time block for each doctor */\n  .schedule-block {\n    width: 50px;  /* Width for each time block */\n    height: 30px; /* Adjust height if needed */\n    border-radius: 4px;\n  }\n  \n  /* Color styles for schedule blocks */\n  .slot-orange {\n    background-color: #ff9933;\n  }\n  \n  .slot-grey {\n    background-color: #808080;\n  }\n  \n  .slot-green {\n    background-color: #33cc33;\n  }\n  \n  .slot-purple {\n    background-color: #800080;\n  }\n  \n  /* Responsive design */\n  @media (max-width: 768px) {\n    .card-title {\n      font-size: 16px;\n    }\n  \n    .schedule-grid {\n      grid-template-columns: 140px repeat(auto-fill, 40px);\n    }\n  \n    .schedule-block {\n      width: 40px;\n    }\n  }\n  \n  table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: center;\n  }\n  \n  td, th {\n    border: 1px solid transparent;\n    text-align: left;\n    padding: 4px;\n    width: auto;\n  }\n\n  .card {\n    height: auto !important;\n  }\n\n.appointment-card {\n    height: 240px !important;\n    max-height: 240px !important;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    border-radius: 15px !important;\n}\n\n.dashboard-appointments-column {\n  align-self: flex-start;\n}\n\n.dashboard-appointments-column > * {\n  width: 100%;\n}\n\n.dashboard-appointments-card {\n  height: 240px !important;\n  max-height: 240px !important;\n}\n\n.appointment-card .card-body {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n  padding: 12px 12px 8px !important;\n}\n\n.appointment-card .appointments-list {\n  flex: 1;\n  overflow-y: auto !important;\n  overflow-x: hidden;\n  min-height: 0;\n  margin-top: 0;\n}\n\n.appointment-card .appointment-row-accent {\n  border-left: 5px solid transparent;\n  padding-left: 10px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.dashboard-appointments-card .card-title {\n  margin-bottom: 0;\n}\n\n.dashboard-appointments-card .appointments-list .list-group-item {\n  padding: 8px 0;\n}\n\n\n.doctor-schedule {\n  height: 400px !important;\n}\n\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip-container .tooltip {\n  visibility: hidden;\n  width: 150px;\n  background-color: rgba(0,0,0,0.9);\n  color: #fff;\n  text-align: center;\n  border-radius: 4px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%; /* Position the tooltip above the div */\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s;\n  border: 1px solid black;\n}\n\n.tooltip-container:hover .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
